import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Car } from './../../modelo/interfaces';
import { SimuladorService } from './../../datos/simulador.service';
import { ServicioAlertas } from './../../libs/ruvpp-angular2-comun/ServicioAlertas';
import { ServicioIndicadorCarga } from './../../libs/ruvpp-angular2-comun/indicador-carga';
import { TabMenuModule } from 'primeng/tabmenu';
import { MenuItem } from 'primeng/api';

export class PrimeCar implements Car {
    constructor(public vin?, public year?, public brand?, public color?) { }
}

@Component({
    selector: 'app-example',
    templateUrl: './example.component.html',
    styleUrls: ['./example.component.css']
})
export class ExampleComponent implements OnInit {

    uploadedFiles: any[] = [];



    items: MenuItem[];
    activeItem: MenuItem;



    displayDialog: boolean;

    car: Car = new PrimeCar();

    selectedCar: Car;

    newCar: boolean;

    cars: Car[];

    cols: any[];

    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga,private servicioAlertas: ServicioAlertas, private service: SimuladorService) { }

    ngOnInit() {
        this.service.getCarsSmall().then(cars => this.cars = cars);

        this.cols = [
            { field: 'vin', header: 'Vin' },
            { field: 'year', header: 'Year' },
            { field: 'brand', header: 'Brand' },
            { field: 'color', header: 'Color' }
        ];


        this.items = [
            { label: 'Home', icon: 'pi pi-fw pi-home', routerLink: 'info'  },
            { label: 'Calendar', icon: 'pi pi-fw pi-calendar', routerLink: 'message' },
            { label: 'Edit', icon: 'pi pi-fw pi-pencil' },
            { label: 'Documentation', icon: 'pi pi-fw pi-file' },
            { label: 'Settings', icon: 'pi pi-fw pi-cog' }
        ];

        this.activeItem = this.items[0];

    }

    showDialogToAdd() {
        this.newCar = true;
        this.car = new PrimeCar();
        this.displayDialog = true;
    }

    save() {
        const cars = [...this.cars];
        if (this.newCar) {
            cars.push(this.car);
        } else {
            cars[this.findSelectedCarIndex()] = this.car;
        }
        this.cars = cars;
        this.car = null;
        this.displayDialog = false;
    }

    delete() {
        const index = this.findSelectedCarIndex();
        this.cars = this.cars.filter((val, i) => i !== index);
        this.car = null;
        this.displayDialog = false;
    }

    onRowSelect(event) {
        this.newCar = false;
        this.car = { ...event.data };
        this.displayDialog = true;
    }

    findSelectedCarIndex(): number {
        return this.cars.indexOf(this.selectedCar);
    }

    /**
     * 
     */
    public Alerta() {

        this.servicioIndicadorCarga.mostrar('Procesando Informaci�n del Excel ...');

        //Swal.fire({
        //    title: 'Are you sure?',
        //    text: 'You will not be able to recover this imaginary file!',
        //    icon: 'warning',
        //    showCancelButton: true,
        //    confirmButtonText: 'Yes, delete it!',
        //    cancelButtonText: 'No, keep it'
        //}).then((result) => {
        //    if (result.value) {
        //        Swal.fire(
        //            'Deleted!',
        //            'Your imaginary file has been deleted.',
        //            'success'
        //        )
        //        // For more information about handling dismissals please visit
        //        // https://sweetalert2.github.io/#handling-dismissals
        //    } else if (result.dismiss === Swal.DismissReason.cancel) {
        //        Swal.fire(
        //            'Cancelled',
        //            'Your imaginary file is safe :)',
        //            'error'
        //        )
        //    }
        //})
    }

    /**
     * 
     * @param event
     * @param fileUpload
     */
    public onFileUpload(event: { files: File }, fileUpload): void {

        console.log('onFileUpload -->> ', event)

        var excelParametros = { opcion: 'Vivienda' };

        this.service.AgregarDocumento(event, excelParametros).subscribe(resultado => {

            console.log('resultado ?? -->> ', resultado);

            //if (resultado.code == 200) {




            //} else {



            //}

        });;

    }


}